export default "__VITE_ASSET__2e47341f__"